import { startOfDay } from 'date-fns'
import { zonedTimeToUtc } from 'date-fns-tz'

const startOfDayTimezoned = (date: Date, timezone: string): Date => {
  const modifiedDate = zonedTimeToUtc(startOfDay(date), timezone)
  return modifiedDate
}

export { startOfDayTimezoned }
